import { PrerequisiteLoadingService, Prerequisite } from "../loading/prerequisite-loading-service";
import { AgentProfileEntityServiceImplementation } from "./agent-profile-entity-service";
import { MyTeamsEntityServiceImplementation } from "./my-teams-entity-service";
import "./agent-profile-entity-model";
import "./my-teams-entity-model";
import sdServicesModule from "../sdServicesModule";

sdServicesModule
  .service("agentProfileEntityService", AgentProfileEntityServiceImplementation)
  .service("myTeamsEntityService", MyTeamsEntityServiceImplementation)
  .run(
    (
      prerequisiteLoadingService: PrerequisiteLoadingService,
      agentProfileEntityService: AgentProfileEntityServiceImplementation
    ) => {
      prerequisiteLoadingService.registerCallbackForPrerequisite(
        "agentProfileEntityService",
        (prerequisite: Prerequisite) => {
          return agentProfileEntityService.prerequisiteLoadCallback(prerequisite);
        },
        false
      );
    }
  );
